/* eslint-disable react/prop-types */
import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PagedReadyContextType {
  setPagedReady: (ready: boolean) => void;
  isPagedReady: boolean;
}

const PagedReadyContext = createContext<PagedReadyContextType | undefined>(undefined);

export const usePagedReady = (): PagedReadyContextType => {
  const context = useContext(PagedReadyContext);
  if (!context) {
    throw new Error('usePagedReady must be used within a PagedReadyProvider in future');
  }
  return context;
};

interface PagedReadyProviderProps {
  children: ReactNode;
}

export const PagedReadyProvider: React.FC<PagedReadyProviderProps> = ({ children }) => {
  const [isPagedReady, setPagedReady] = useState(false);

  return (
    <PagedReadyContext.Provider value={{ isPagedReady, setPagedReady }}>
      {children}
    </PagedReadyContext.Provider>
  );
}; 